import { createGlobalStyle } from 'styled-components';

import './fontFace.css';

export const GlobalStyles = createGlobalStyle`
	body {
		margin: 0;
	}

	p {
		margin: 0;
	}
	
	* { 
		box-sizing: border-box;
    text-decoration: none;
	}
	:root {
		--max-content-width: 1360px;
    --color-ink: #203b2f;
    --color-accent: #315940;
    --color-accent-hover: #264632;
    --color-muted: #6c7469;
    --color-surface: #fffdf8;
    --color-background: #f7f5ee;
    --color-line: #e1e5da;
	}

  body {
    background: var(--color-background);
    color: var(--color-ink);
    font-family: 'Gilroy', system-ui, sans-serif;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
  }

  a { color: inherit; }
  button, input, select, textarea { font: inherit; }
  button, a { -webkit-tap-highlight-color: transparent; }
  :focus-visible {
    outline: 2px solid var(--color-accent);
    outline-offset: 4px;
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      transition-duration: 0.01ms !important;
    }
  }
`;
